<template>
    <!-- TODO css -->
    <modal @close="close">
        <h3>Pre-paid product allocation request</h3>
        <form @submit.prevent>
            <div class="large-form">
                <img v-if="localProduct.image_url" :src="localProduct.image_url" width="150" alt="Product image" style="display: inline-block">
                <p>If your allocated units are running low, <br />use this form to request more units.<p>
                <div class="form-line" style="width: 200px; margin: 20px auto 0;">
                    <div class="form-field">
                        <label>Number of units</label>
                        <input v-model="item.stock" type="number" required :min="localProduct.reorder_moq">
                        <div v-if="localProduct.reorder_moq > 1" class="field-note">Reorder MOQ: <b>{{ localProduct.reorder_moq }} units</b></div>
                    </div>
                </div>
                <div class="modal-errors">
                    <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
                </div>
            </div>
            <div class="form-actions">
                <div class="ws-button ws-button-secondary" data-action="cancel" @click="modals.productRestock = false">CANCEL</div>
                <div class="ws-button ws-button-main" type="submit" @click="submit">{{ type === 'create' ? 'REQUEST PRODUCT UNITS' : 'UPDATE REQUEST'}}</div>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "ProductRestockModal",
    components: {Modal},
    props: {
        productId: Number,
        requestId: Number,
        fetchItem: {type: Boolean, default: false},
        type: {type: String, default: 'create'}, // 'create' or 'edit'
    },
    data() {
        return {
            item: {stock:0},
            localProduct: {},
            errors: {}
        }
    },
    methods: {
        async submit() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Stock', value: this.item.stock, rules: ['required', 'posInt'] },
            ]);
            if (Object.keys(this.errors).length) return;

            if (this.type === 'create') {
                let response = await this.dispatchWaitAndNotify('createRestockRequest', {productId: this.localProduct.id, payload: {stock: this.item.stock, team_id:this.$store.state.teamId,send_email:true}});
                this.$emit('created', response.id);
            } else {
                let response = await this.dispatchWaitAndNotify('updateProductRequest', {requestId: this.requestId, payload: {stock: this.item.stock} });
                this.$emit('updated', response.id);
            }
        },
        close() {
            this.modals.productRestock = false;
        }
    },
    async mounted() {
        if (this.fetchItem) {
            // this.$store.commit('fetchProduct', {});
            let product = await this.dispatchWaitAndNotify('fetchProduct', {productId: this.productId, params: {noCommit:true}}, false, true);
            this.localProduct = product;
        } else {
            this.localProduct = this.storeProduct;
        }
        if (this.localProduct.reoorder_moq > 1) this.item.stock = this.localProduct.reoorder_moq;
        else this.item.stock = 10;
        
        if (this.type === 'edit') {
            await this.dispatchWaitAndNotify('fetchProductRequest', {requestId: this.requestId}, false, true);
            this.item.stock = this.request.stock;
        }
    },
    computed: {
        storeProduct() {
            return this.$store.state.product.detail;
        },
        request() {
            return this.$store.state.product.request.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>

<style scoped>

</style>